import Dashboard from "./Dashboard";
import AddWidgetDialog from "./AddWidgetDialog";
import GridLayout from "./GridLayout";
import SideBar from "./Sidebar";
import Widget from "./Widget";
import Selection from "./Selection";
import TabBar from "./TabBar";

export default Dashboard;
export {
    AddWidgetDialog,
    GridLayout,
    SideBar,
    Widget,
    Selection,
    TabBar,
};
